import { useMutation } from '@tanstack/react-query';

import type { ValuePropResponse, ValueProposition } from '../../domain/preferences';
import { queryClient } from '../../queryClient';

import { preferencesApi } from './api';
import { preferencesQueryKey } from './preferencesQueryKey';
import { usePreferencesMutation } from './usePreferencesMutation';

const MUTATION_KEY = ['update-preferences-value-prop'];

const updateFunction = async (valueProp: ValueProposition) => {
  await preferencesApi.setValuePropSettings(valueProp);
  queryClient.setQueryData<ValuePropResponse>(preferencesQueryKey.valueProp(), (prevValueProp) => ({
    default: prevValueProp?.default || valueProp,
    custom: valueProp,
  }));
};

export const useValuePropPreferencesMutation = (onClose: () => void) => {
  return usePreferencesMutation({ mutationKey: MUTATION_KEY, updateFunction, onClose });
};

export const useUpdateValuePropositionMutation = () => {
  return useMutation({
    mutationKey: MUTATION_KEY,
    mutationFn: updateFunction,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: preferencesQueryKey.suggestedMetrics() }),
  });
};
